import { render } from "./TransferPayoutTable.vue?vue&type=template&id=5c0398bd"
import script from "./TransferPayoutTable.vue?vue&type=script&lang=js"
export * from "./TransferPayoutTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__